/* eslint-disable */
/**
 * AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Generated by: scripts/generate-embedded-inkjs-exports.mjs
 * Source: inkjs@2.2.0 (inkjs/full entry)
 * Generated at: 2026-01-28T00:00:00.000Z
 *
 * Note: inkjs 2.2.0 uses UMD bundle, exports determined from ink.d.ts
 */

export const EMBEDDED_INKJS_22_VERSION = "2.2.0" as const;

export const EMBEDDED_INKJS_22_NAMED_EXPORTS = [
  "Compiler",
  "CompilerOptions",
  "InkList",
  "JsonFileHandler",
  "PosixFileHandler",
  "Story"
] as const;
